<div class="walt-intro flexRow jcC" [class.info-boxes-refreshing]="isRefreshing()">
    <div class="radio-icon">
        <app-icon [icon]="waltIcon()" fontSize="60px" [centered]="true" />
    </div>
    <div class="walt-info">
        <p class="name">{{walt().id}}</p>
    </div>

    <div class="mT10 mB10 flexRow aiC">
        @if (isRefreshing()) {
             <p>{{'walt.updating-info' | translate}}...</p>
        } @else {
            <p style="text-transform: lowercase;">{{'walt.last-updated' | translate}}:</p>
            @if (didRefreshFail()) {
                <p class="mL4 red">{{ 'walt.no-refresh' | translate}}</p>
            } @else {
                <p class="mL4" data-testid="WaltDetails-LastUpdated" [matTooltip]="lastReportedAt() ? (lastReportedAt() | date: hoverDateFormat) : ''" [class.red]="isLastReportStale()">{{lastReportedAt() | date:updatedDateFormat}}</p>
            }
            <button class="round-button refresh-button" data-testid="WaltDetails-Refresh" [disabled]="!hasDeviceManagementEditPerms()" (click)="onRefreshWalt()">
                <app-icon [faIcon]="'far fa-arrows-rotate'" [fontSize]="'12px'" />
            </button>
        }
    </div>

    <div class="action-container">
        <span class="flexColumn aiC jcC taC w60" [class.action-disabled]="actionsDisabled()">
            <app-walt-sound-control
                [walt]="walt()"
                [canEdit]="hasDeviceManagementEditPerms()"
                [disabled]="actionsDisabled()"
                [enhancementsEnabled]="true"
                [styleVariant]="'round'"
            />
            <p class="mT5">{{'walt.ring' | translate}}</p>
        </span>
        <span class="flexColumn aiC jcC taC w60" [class.action-disabled]="updateDisabled()">
            <button class="action-button" data-testid="WaltDetails-Update" [disabled]="updateDisabled()" (click)="onInstallUpdate()">
                <app-icon [faIcon]="'far fa-arrow-down-to-bracket'" [fontSize]="'18px'" />
            </button>
            <p class="mT5">{{'generics.update' | translate}}</p>
        </span>
        <span class="flexColumn aiC jcC taC w60" [class.action-disabled]="commandsDisabled()">
            <button class="action-button" data-testid="WaltDetails-Off" [disabled]="commandsDisabled()" (click)="onPowerOffWalt()">
                <app-icon [faIcon]="'far fa-power-off'" [fontSize]="'18px'" />
            </button>
            <p class="mT5">{{'generics.off' | translate}}</p>
        </span>
        <span class="flexColumn aiC jcC taC w60" [class.action-disabled]="commandsDisabled()">
            <button class="action-button" data-testid="WaltDetails-Restart" [disabled]="commandsDisabled()" (click)="onRebootWalt()">
                <app-icon [faIcon]="'far fa-arrow-rotate-left'" [fontSize]="'18px'" />
            </button>
            <p class="mT5">{{'walt.restart' | translate}}</p>
        </span>
    </div>

    <span class="label-text">{{'walt.assigned-site' | translate}}</span>
    <app-dropdown [ngModel]="waltFacility()" [dropdownInput]="facilityDropdown()"
        (dropdownOutput)="onFacilityOutput($event)" [style]="{width: '100%'}"
        [readonly]="!hasDeviceManagementEditPerms() || facilityDropdown().length === 1" />

    <span class="label-text">{{'walt.craft' | translate}}</span>
    <app-dropdown [ngModel]="selectedCraft()" [dropdownInput]="craftsDropdown()"
        [readonly]="!hasDeviceManagementEditPerms()" [emptyOption]="'walt.no-craft-assigned'"
        [emptyOptionAsPlaceholder]="true" [style]="{width: '100%'}" (dropdownOutput)="onCraftOutput($event)" />

    @if (walt().loggedIn && canLogOut() && hasDeviceManagementEditPerms()) {
    <button class="blue-lt small w100p mT10 flexRow jcC" data-testid="WaltDetails-Logout" (click)="onRemoteLogout()">
        <app-icon [faIcon]="'fa fa-sign-out-alt'" fontSize="20px" />
        <p class="pL5">{{'generics.logout' | translate}}</p>
    </button>
    }

    <!-- * info boxes -->
    <div class="info-box" style="min-height: 60px;">
        <div class="info-box-content">
            <p>{{'walt.status-header' | translate}}</p>
            <p data-testid="WaltDetails-Status">{{waltStatusLabel() | translate}}</p>
        </div>
        @if (poweredOffReasonKey(); as reasonKey) {
            <div class="info-box-content">
                <p>{{'walt.reason' | translate}}</p>
                <p data-testid="WaltDetails-PowerOffReason">{{reasonKey | translate}}</p>
            </div>
        }
        @if (person() && isActiveStatus()) {
            <div class="info-box-content" style="max-height: 27px;">
                <p>{{'walt.active-user' | translate}}</p>
                <span class="flexRow person-name-container">
                    <app-avatar [avatarInput]="{
                            height: 20,
                            width: 20,
                            img: person().avatarFile,
                            placeholder: { 'icon': 'fas fa-user', 'iconColor': 'white' }}" 
                        [readonly]="true"
                    />
                    <p class="mL2">{{person().fullName}}</p>
                </span>
            </div>
        }
        <div class="info-box-content">
            <p>{{'walt.battery' | translate}}</p>
            <span class="flexRow" data-testid="WaltDetails-BatteryValue" [class.red]="isDeadBattery()">
                @if (isDocked()) {
                    <app-icon [faIcon]="'fa fa-battery-bolt'" fontSize="14px" />
                }
                @if (isDeadBattery()) {
                    <app-icon data-testid="WaltDetails-DeadBatteryIcon" [faIcon]="'far fa-battery-empty'" fontSize="14px" />
                }
                <p class="mL5" data-testid="WaltDetails-Battery">{{!isNoConnection() && walt().battery !== null && walt().battery !== undefined ? (walt().battery | percent) : ('generics.unknown' | translate)}}</p>
            </span>
        </div>
        @if (poweredOffAt(); as poweredOffAt) {
            <span class="flexRow jcC aiC">
                <p class="info-box-subtitle" style="text-transform: lowercase;">{{'walt.status.powered-off' | translate}}:</p>
                <p class="info-box-subtitle pL2" data-testid="WaltDetails-PoweredOffAt" [matTooltip]="poweredOffAt | date: hoverDateFormat">{{poweredOffAt | date: updatedDateFormat}}</p>
            </span>
        }
    </div>

    <div class="info-box" style="min-height: 100px;">
        <p class="info-box-title" data-testid="WaltDetails-LocationTitle">{{ locationTitleKey() | translate }}</p>
        @if (showOnSite()) {
            <div class="info-box-content">
                <p>{{'walt.on-site' | translate}}</p>
                <p>{{isOnSite() === true ? ('generics.yes' | translate) : ('generics.no' | translate)}}</p>
            </div>
        }
        <div class="info-box-content">
            <p>{{'generics.location' | translate}}</p>
            @if (mapLocation() && locationText()) {
                <button type="button" class="text-link location-link" data-testid="WaltDetails-Location" (click)="locationClickOutput.emit()">{{locationText()}}</button>
            } @else {
                <p data-testid="WaltDetails-Location">{{locationText() || (locationFallbackKey() | translate)}}</p>
            }
        </div>
        @if (walt().wrangler?.id) {
        <div class="info-box-content">
            <p>{{'walt.wrangler' | translate}}</p>
            <p class="text-link">{{walt().wrangler.id}}</p>
        </div>
        <div class="info-box-content">
            <p>{{'walt.slot-2' | translate}}</p>
            <p class="text-link">{{walt().wrangler.slot}}</p>
        </div>
    }
        <span class="flexRow jcC aiC">
            <p class="info-box-subtitle">{{'walt.location-updated' | translate}}:</p>
            <p class="info-box-subtitle pL2" data-testid="WaltDetails-LocationUpdated" [matTooltip]="walt().locationUpdated ? (walt().locationUpdated | date: hoverDateFormat) : ''" [class.red]="didRefreshFail() || isLocationStale()">{{walt().locationUpdated | date: updatedDateFormat}}</p>
        </span>
    </div>

    <div class="info-box" style="min-height: 120px;">
        <p class="info-box-title">{{'walt.about' | translate }}</p>
        <div class="info-box-content">
            <p>{{'walt.product-name' | translate}}</p>
            <p>{{getWaltModelLabel() | translate}}</p>
        </div>
        <div class="info-box-content">
            <p>{{'walt.serial-number' | translate}}</p>
            <p class="text-link">{{walt().id}}</p>
        </div>
        <div class="info-box-content">
            <p>{{'walt.version' | translate}}</p>
            <p>{{walt().version}}</p>
        </div>
    </div>

    @if (wifi(); as wifi) {
        <div class="info-box" data-testid="WaltDetails-Wifi">
            <p class="info-box-title" data-testid="WaltDetails-Wifi-Title">{{'walt.wifi-network' | translate}}</p>
            <div class="info-box-content">
                <p>{{'walt.network' | translate}}</p>
                <p data-testid="WaltDetails-Wifi-Network">{{wifi.ssid || ('generics.unknown' | translate)}}</p>
            </div>
            <div class="info-box-content">
                <p>{{'walt.mac' | translate}}</p>
                <p data-testid="WaltDetails-Wifi-Mac">{{walt().macAddress || ('generics.unknown' | translate)}}</p>
            </div>
            <div class="info-box-content">
                <p>{{'walt.ip' | translate}}</p>
                <p data-testid="WaltDetails-Wifi-Ip">{{wifi.ip || ('generics.unknown' | translate)}}</p>
            </div>
        </div>
    }

    @for (row of cellularRows(); track row.slot) {
        <div class="info-box" [attr.data-testid]="'WaltDetails-Cellular-' + row.slot">
            <p class="info-box-title" [attr.data-testid]="'WaltDetails-Cellular-' + row.slot + '-Title'">{{'walt.cellular-network' | translate}}@if (useDualSims()) { ({{(row.active ? 'generics.active' : 'generics.inactive') | translate}})}</p>
            @if (row.empty && useDualSims()) {
                <div class="info-box-content">
                    <p [attr.data-testid]="'WaltDetails-Cellular-' + row.slot + '-NoSim'">{{'walt.no-sim' | translate}}</p>
                </div>
            } @else {
                <div class="info-box-content">
                    <p>{{'walt.network' | translate}}</p>
                    <p [attr.data-testid]="'WaltDetails-Cellular-' + row.slot + '-Network'">{{row.sim?.carrier || ('generics.unknown' | translate)}}</p>
                </div>
                @if (!useDualSims() || row.active) {
                    <div class="info-box-content">
                        <p>{{'generics.status' | translate}}</p>
                        <p [attr.data-testid]="'WaltDetails-Cellular-' + row.slot + '-Status'">{{(row.connected ? 'generics.connected' : 'generics.disconnected') | translate}}</p>
                    </div>
                }
                <div class="info-box-content">
                    <p>{{'walt.imei' | translate}}</p>
                    <p [attr.data-testid]="'WaltDetails-Cellular-' + row.slot + '-Imei'">{{row.sim?.imei || ('generics.unknown' | translate)}}</p>
                </div>
                <div class="info-box-content">
                    <p>{{'walt.iccid' | translate}}</p>
                    <p [attr.data-testid]="'WaltDetails-Cellular-' + row.slot + '-Iccid'">{{row.sim?.iccid || ('generics.unknown' | translate)}}</p>
                </div>
            }
        </div>
    }

    @if (company(); as company) {
        <div class="info-box" style="min-height: 60px;">
            <p class="info-box-title">{{'walt.company' | translate}}</p>
            <div class="info-box-content">
                @if (company.logo) {
                    <img style="max-width: 60px;max-height: 60px;" [src]="company.logo" [alt]="company.name" [title]="company.name">
                }
                <p>{{ company.name }}</p>
            </div>
        </div>
    }

    @if (!isOnSite() && showOnSite()) {
        <div class="info-box">
            <p class="info-box-title">{{'walt.date-reported-off-site' | translate}}</p>
            <div class="info-box-content">
                <p>
                    @if (!walt().latestFacilityExit) {
                        {{'generics.unknown' | translate}}
                    } @else {
                        <span data-testid="WaltDetails-DateReportedOffSite" [matTooltip]="walt().latestFacilityExit | date: hoverDateFormat">{{walt().latestFacilityExit | date: updatedDateFormat}}</span>
                    }
                </p>
            </div>
        </div>
    }

</div>
